import { getAccountId, getUrlWithSearchParams, membersLink } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";
import { generatePath } from "react-router-dom";

export const customerLink = membersLink + "/api/v1/customers/me";
export const subscribeLink = membersLink + "/subscribe";

export const supportLink = "https://kb.helium10.com/hc/en-us/requests/new";
export const tokenManagerListLink = membersLink + "/new-account/tokens-manager-list";

export const mrsLink = "/managed-refund-service";

export const onboardingRoute = mrsLink + "/onboarding";
export const acceptFeeTermsRoute = mrsLink + "/feeTerms";
export const landingRoute = mrsLink + "/landing";
export const StrictRestrictRoutes = [onboardingRoute, acceptFeeTermsRoute, landingRoute];

export const claimCasesRoute = mrsLink + "/claim_cases";
export const inboundRoute = mrsLink + "/inbound";
export const documentCenterRoute = mrsLink + "/documentCenter";
export const billingRoute = mrsLink + "/billing";
export const packFeeRoute = mrsLink + "/packFee";
export const refundGenieRoute = mrsLink + "/refundGenie";
export const inboundAccountRoute = mrsLink + "/inboundAccount";

export const getRedirectMrsRoute = (accountId: string) => generatePath(mrsLink, { accountId });

export const getRedirectRoute = (route: string) => {
  const accountId = getAccountId();
  return generatePath(route, { accountId });
};

export const goToOnboarding = () => {
  return getUrlWithSearchParams(onboardingRoute, {}, { hasAccountId: true });
};

export const goToAcceptFeeTerms = () => {
  return getUrlWithSearchParams(acceptFeeTermsRoute, {}, { hasAccountId: true });
};

export const goToLanding = () => {
  return getUrlWithSearchParams(landingRoute, {}, { hasAccountId: true });
};

export const goToInbound = (queryParamsProps?: StringifiableRecord) => {
  return getUrlWithSearchParams(inboundRoute, queryParamsProps || {}, { hasAccountId: true });
};

export const goToMrs = () => {
  return getUrlWithSearchParams(mrsLink, {}, { hasAccountId: true });
};

export const goToMemberspage = () => {
  const accountId = getAccountId();
  window.location.href =
    "https://pages.helium10.com/refund-service-demo?medium=direct&source=memberspage&campaign=solution-refunds&content=mrsdemo&accountId=" +
    accountId;
};
